
import { Check, CheckButton, Flex, themeColor, Copy } from '@elparking/components'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled(Flex)`
    border-radius: 3px;
    outline: 1px solid ${(props) => props.checked ? themeColor('accent') : themeColor('gray10')};
    :hover {
        outline: 1px solid ${themeColor('accent')}
    }
`

Container.propTypes = {
    checked: PropTypes.bool,
}

export const CarTypeCard = ({icon: Icon, label, checked, name, onChange, keyId, isLoading, width}) => {
    const labelComponent = <Container alignItems='center' checked={checked} flexDirection='column' width='100%' height='auto' justifyContent='space-between' padding='10px'>
        <Icon height={'40px'} color={checked ? 'accent_dark70' : 'black'} />
        <Copy padding='5px 0 0 0' fontColor={checked ? 'accent_dark70' : 'gray90'} fontWeight='book' fontSize={'small'}>{label}</Copy>
    </Container>
    return <Check
      checkButtonElement={CheckButton.labelInside}
      labelComponent={labelComponent}
      width={width}
      height='100%'
      borderColor='gray10'
      onChange={onChange}
      checked={checked}
      id={`vehicle-type-${keyId}`}
      name={name}
      key={keyId}
      type='checkbox'
      disabled={isLoading}
      margin='4px'
    />
}
CarTypeCard.defaultProps = {
    checked: false,
    isLoading: false,
    width: '100%',
}

CarTypeCard.propTypes = {
    icon: PropTypes.object,
    label: PropTypes.node,
    checked: PropTypes.bool,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    keyId: PropTypes.string,
    width: PropTypes.any,
}

export default CarTypeCard
